// Trustpilot's official star-rating images, self-hosted under /public and selected by the
// half-rounded rating Trustpilot returns (1, 1.5 … 5; the scale has no 0.5). Self-hosting keeps
// the stars local, so they paint instantly with no cross-origin request.
const TRUSTPILOT_STARS_IMAGE_BASE = '/images/trustpilot/stars';

export function getTrustpilotStarsImageUrl(stars: number): string {
  return `${TRUSTPILOT_STARS_IMAGE_BASE}/${stars}.png`;
}
